<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" 
              :class="{active: activeTab === tab.label}" 
              @click="switchTab(tab)">
          {{ tab.label }}
        </span>
      </div>
      <button type="button" class="refresh-btn" @click="onRefresh">刷新</button>
    </div>

    <!-- 设备信息内容区 -->
    <div v-if="activeTab==='设备信息'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2" @submit.prevent="onSearch">
          <div class="form-fields">
            <div class="form-item">
              <label for="deviceNo">设备编号：</label>
              <select id="deviceNo" class="form-input" v-model="query.deviceNo">
                <option value="">全部</option>
                <option v-for="device in deviceOptions" 
                        :key="device.deviceNo" 
                        :value="device.deviceNo">
                  {{ device.deviceNo }}
                </option>
              </select>
            </div>
            <div class="form-item">
              <label for="serviceStatus">服务状态：</label>
              <select id="serviceStatus" class="form-input" v-model="query.serviceStatus">
                <option value="">全部</option>
                <option v-for="status in serviceStatusOptions" 
                        :key="status.value" 
                        :value="status.value">
                  {{ status.label }}
                </option>
              </select>
            </div>
            <div class="form-item">
              <label for="location">安装位置：</label>
              <select id="location" class="form-input" v-model="query.location">
                <option value="">全部</option>
                <option v-for="loc in locationOptions" 
                        :key="loc" 
                        :value="loc">
                  {{ loc }}
                </option>
              </select>
            </div>
            <div class="form-item">
              <label for="installDate">安装时间：</label>
              <input id="installDate" class="form-input" type="date" v-model="installDateForInput" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onCreate">新增</button>
            <button type="submit" class="search-btn-green" @click="onSearch">搜索</button>
            <button type="button" class="clear-btn" @click="onReset">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>设备ID</th>
                <th>设备编号</th>
                <th>设备名称</th>
                <th>设备洗衣码</th>
                <th>设备取衣码</th>
                <!-- <th>洗衣程序</th> -->
                <th>安装位置</th>
                <th>安装时间</th>
                <th>服务状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="10" style="text-align:center;color:#bbb;">数据加载中...</td>
              </tr>
              <tr v-else-if="deviceList.length === 0">
                <td colspan="10" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, index) in deviceList" :key="item.deviceId">
                  <td>{{ index + 1 + (query.pageNo - 1) * query.pageSize }}</td>
                  <td>{{ item.deviceId }}</td>
                  <td>{{ item.deviceNo }}</td>
                  <td>{{ item.deviceName }}</td> 
                  <td class="qrcode-cell">
                    <div v-if="!item.washQRCodeImageUrl" class="no-image">无图片</div>
                    <img v-else 
                        :src="item.washQRCodeImageUrl" 
                        alt="设备洗衣二维码"
                        class="qrcode-image"
                        @error="handleImageError"
                        @click="previewImage(item.washQRCodeImageUrl)"
                        loading="lazy"
                        style="cursor: pointer;">
                  </td>
      
                  <td class="qrcode-cell">
                    <div v-if="!item.takeQRCodeImageUrl" class="no-image">无图片</div>
                    <img v-else 
                        :src="item.takeQRCodeImageUrl" 
                        alt="设备取衣二维码"
                        class="qrcode-image"
                        @error="handleImageError"
                        @click="previewImage(item.takeQRCodeImageUrl)"
                        loading="lazy"
                        style="cursor: pointer;">
                  </td>
                  <!-- <td>
                    <template v-if="item.washPrograms && item.washPrograms.length">
                      <span v-for="(p, idx) in item.washPrograms" 
                            :key="p.programName || idx" 
                            class="program-item">
                        {{ p.programName }}({{ p.durationMinutes }}分钟){{ idx < item.washPrograms.length - 1 ? '、' : '' }}
                      </span>
                    </template>
                    <span v-else class="no-program">无程序</span>
                  </td> -->
                  <td>{{ item.location || '--' }}</td>
                  <td>{{ item.installTime || '--' }}</td>
                  <td>
                    <span class="status-badge" :class="getStatusClass(item.serviceStatus)">
                      {{ getServiceStatusShowText(item) }}
                    </span>
                  </td>

                  <td>
                    <button class="btn-edit" @click="onEdit(item)">编辑</button>
                    <button class="btn-delete" @click="onDelete(item)">删除</button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        
        <!-- 设备服务端分页 -->
        <div class="pagination" v-if="deviceTotal > 0">
          <button class="page-btn" :disabled="query.pageNo === 1" @click="changePage(1)" title="首页">«</button>
          <button class="page-btn" :disabled="query.pageNo === 1" @click="changePage(query.pageNo - 1)">&lt;</button>
          <span v-for="p in Math.ceil(deviceTotal / query.pageSize)" :key="p">
            <button class="page-btn" :class="{active:query.pageNo===p}" @click="changePage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="query.pageNo === Math.ceil(deviceTotal / query.pageSize)" @click="changePage(query.pageNo+1)">&gt;</button>
          <button class="page-btn" :disabled="query.pageNo === Math.ceil(deviceTotal / query.pageSize)" @click="changePage(Math.ceil(deviceTotal / query.pageSize))">»</button>
          <div class="page-jump">
            <input type="number" v-model.number="pageInput" min="1" :max="Math.ceil(deviceTotal / query.pageSize)" style="width:50px;"/>
            <button class="jump-btn" @click="jumpPage">跳转</button>
            <span style="margin-left:10px;">共{{deviceTotal}}条数据</span>
          </div>
        </div>
        <div class="pagination">
          <span style="color: tomato;">备注：(根据实际情况洗衣程序包括：桶自洁2分钟 单脱水5分钟 快洗33分钟 标准洗46分钟 大件洗49分钟）</span>
        </div>
      </div>
    </div>

    <!-- 故障统计内容区 -->
    <div v-else-if="activeTab==='故障统计'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2" @submit.prevent="onFaultSearch">
          <div class="form-fields">
            <div class="form-item">
              <label for="faultDeviceNo">设备编号：</label>
              <select id="faultDeviceNo" class="form-input" v-model="faultQuery.deviceNo">
                <option value="">全部</option>
                <option v-for="device in faultdeviceOptions" 
                        :key="device.deviceNo" 
                        :value="device.deviceNo">
                  {{ device.deviceNo }}
                </option>
              </select>
            </div>

            <div class="form-item">
              <label for="faultDeviceLocation">设备位置：</label>
              <select id="faultDeviceLocation" class="form-input" v-model="faultQuery.location">
                <option value="">全部</option>
                <option v-for="location in faultlocationOptions" 
                        :key="location" 
                        :value="location">
                  {{ location }}
                </option>
              </select>
            </div>
            <div class="form-item">
              <label for="handleStatus">处理状态：</label>
              <select id="handleStatus" class="form-input" v-model="faultQuery.handleStatus">
                <option value="">全部</option>
                <option v-for="status in handleStatusOptions" 
                        :key="status.value" 
                        :value="status.value">
                  {{ status.label }}
                </option>
              </select>
            </div>
            <div class="form-item">
              <label for="startDate">开始日期：</label>
              <input id="startDate" class="form-input" type="date" v-model="startDateInput" />
            </div>
            <div class="form-item">
              <label for="endDate">结束日期：</label>
              <input id="endDate" class="form-input" type="date" v-model="endDateInput" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onFaultSearch">搜索</button>
            <button type="button" class="clear-btn" @click="onFaultReset">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>故障ID</th>
                <th>设备ID</th>
                <th>设备编号</th>
                <th>安装位置</th>
                <th>故障类型</th>
                <th>故障描述</th>
                <th>故障时间</th>
                <th>处理时间</th>
                <th>处理状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="11" style="text-align:center;color:#bbb;">数据加载中...</td>
              </tr>
              <tr v-else-if="faultList.length === 0">
                <td colspan="11" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, index) in faultList" :key="item.faultId">
                  <td>{{ index + 1 + (faultQuery.pageNo - 1) * faultQuery.pageSize }}</td>
                  <td>{{ item.faultId }}</td>
                  <td>{{ item.deviceId }}</td>
                  <td>{{ item.deviceNo }}</td>
                  <td>{{ item.location || '--' }}</td>
                  <td>{{ item.faultType || '--' }}</td>
                  <td class="fault-description">{{ item.faultDesc || '--' }}</td>
                  <td>{{ item.faultTime || '--' }}</td>
                  <td>{{ item.handleTime || '--' }}</td>
                  <td>
                    <span class="status-badge" :class="getFaultStatusClass(item.handleStatus)">
                      {{ getFaultStatusShowText(item) }}
                    </span>
                  </td>
                  <td class="action-buttons">
                    <button v-if="item.handleStatus !== 'RESOLVED'" 
                            class="btn-edit" 
                            @click="onHandleFault(item)">
                      处理
                    </button>
                    <span v-else class="completed-text">已完成</span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        
        <!-- 故障服务端分页-->
        <div class="pagination" v-if="faultTotal > 0">
          <button class="page-btn" :disabled="faultQuery.pageNo === 1" @click="changeFaultPage(1)" title="首页">«</button>
          <button class="page-btn" :disabled="faultQuery.pageNo === 1" @click="changeFaultPage(faultQuery.pageNo - 1)">&lt;</button>
          <span v-for="p in  Math.ceil(faultTotal / faultQuery.pageSize)" :key="p">
            <button class="page-btn" :class="{active:faultQuery.pageNo===p}" @click="changeFaultPage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="faultQuery.pageNo === Math.ceil(faultTotal / faultQuery.pageSize)" @click="changeFaultPage(faultQuery.pageNo+1)">&gt;</button>
          <button class="page-btn" :disabled="faultQuery.pageNo === Math.ceil(faultTotal / faultQuery.pageSize)" @click="changeFaultPage(Math.ceil(faultTotal / faultQuery.pageSize))">»</button>
          <div class="page-jump">
            <input type="number" v-model.number="faultPageInput" min="1" :max="Math.ceil(faultTotal / faultQuery.pageSize)" style="width:50px;"/>
            <button class="jump-btn" @click="jumpFaultPage">跳转</button>
            <span style="margin-left:10px;">共{{faultTotal}}条数据</span> 
          </div>
        </div>
        <div class="pagination">
          <span style="color: tomato;">备注：(故障类型包括：E1进水故障 E2排水故障 E3门盖故障 E9其他故障）</span>
        </div>

      </div>
    </div>

    <!-- 使用统计内容区 -->
    <div v-else-if="activeTab==='使用统计'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2" >
          <div class="form-fields">
            <div class="form-item">
              <label for="deviceId">设备：</label>
              <select 
                id="deviceId" 
                class="form-input"
                v-model="statsQuery.deviceId"
              >
                <option value="">请选择设备</option>
                <option v-for="device in statsDeviceOptions" 
                        :key="device.deviceId" 
                        :value="device.deviceId">
                  {{ device.deviceName }}(设备编号: {{ device.deviceNo }}) (设备位置: {{ device.location }})
                </option>
              </select>
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onStatsSearch">搜索</button>
            <button type="button" class="clear-btn" @click="onStatsReset">清空</button>
            <button type="button" class="search-btn-green" @click="openMultExportReportModal">多设备导出</button>
          </div>
        </form>
      </div>

      <!-- 显示区 -->
      <div class="data-section">
        <div v-if="loading" class="loading-container">
          <div class="loading-text">数据加载中...</div>
        </div>
        <div v-else class="use-stats-container">
          <!-- 选中的设备统计信息 -->
          <div v-if="selectedDeviceStats" class="use-stats-single">
            <div class="use-stats-card">
              <div class="use-stats-card-title">
                <div class="use-stats-label">
                  <span>{{ selectedDeviceStats.deviceName}}</span>
                  <span class="device-id">(设备ID: {{ selectedDeviceStats.deviceId }})</span>
                </div>
                <div class="use-stats-icon">
                  <!-- <span class="export-icon" 
                        @click="exportSingleDeviceReport(selectedDeviceStats)"
                        style="cursor: pointer;"
                        title="导出该设备报表">📥</span> -->
                </div>
              </div>
              <div class="use-stats-card-content">
                <!-- 第一行：基本统计 -->
                <div class="stats-row">
                  <div class="stat-item">
                    <div class="stat-label">设备基本情况</div>
                    <div class="stat-charts">
                      <div class="basic-stat">
                        <div class="stat-title" >使用时长</div>
                        <div class="stat-value">{{ selectedDeviceStats.basicStats?.usageDurationDays || 0 }}天</div>
                      </div>
                      <div class="basic-stat">
                        <div class="stat-title">使用次数</div>
                        <div class="stat-value">{{ selectedDeviceStats.basicStats?.usageCount || 0 }}次</div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="stat-item">
                    <div class="stat-label">故障率</div>
                    <div class="stat-chart-container">
                      <EchartsDoughnutPieChart
                        :chart-data="getFaultRateChartData(selectedDeviceStats)"
                        :show-legend="true"
                        :title="''"
                        :legend-position="'bottom'"
                        :radius="['40%', '65%']"
                        :title-gap="0"
                        :legend-gap="5"
                        height="180px"
                        width="100%"
                        :show-toolbox="false"
                        :show-label="false"
                        :download-file-name="`${selectedDeviceStats.deviceName}-故障率`"
                        :show-legend-data="true"
                        :legend-data-formatter="'{name}: {percent}%'"
                      />
                    </div>
                  </div>
                  
                  <div class="stat-item">
                    <div class="stat-label">故障处理情况</div>
                    <div class="fault-handle-stats">
                      <div class="fault-stat resolved">
                        <span class="fault-icon">✅</span>
                        <span class="fault-text">已处理：{{ selectedDeviceStats.faultHandleStats?.resolvedCount || 0 }}件</span>
                      </div>
                      <div class="fault-stat processing">
                        <span class="fault-icon">🔁</span>
                        <span class="fault-text">处理中：{{ selectedDeviceStats.faultHandleStats?.processingCount || 0 }}件</span>
                      </div>
                      <div class="fault-stat pending">
                        <span class="fault-icon">❌</span>
                        <span class="fault-text">未处理：{{ selectedDeviceStats.faultHandleStats?.pendingCount || 0 }}件</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- 第二行：使用时间统计 -->
                <div class="stats-row">
                  <div class="stat-item full-width">
                    <div class="stat-label">使用时间统计</div>
                    <div class="bar-chart-container">
                      <EchartsBarChart
                        :chart-data="selectedDeviceStats.usageTimeChart?.timePoints || []"
                        :xAxisData="selectedDeviceStats.usageTimeChart?.timePoints || []"
                        :seriesData="selectedDeviceStats.usageTimeChart?.orderCounts || []"
                        :yAxisName="selectedDeviceStats.usageTimeChart?.unit || '次数'"
                        :legendName="selectedDeviceStats.usageTimeChart?.legend || '使用次数'"
                        :title="''"
                        :barColor="'#5470c6'"
                        height="250px"
                        width="100%"
                        :show-toolbox="false"
                        :download-file-name="`${selectedDeviceStats.deviceName}-使用时间分布`"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 未选择设备时的提示 -->
          <div v-else-if="statsQuery.deviceId === ''" class="select-device-prompt">
            <div class="prompt-content">
              <div class="prompt-icon">📊</div>
              <div class="prompt-text">请从上方选择设备I查看使用统计数据</div>
            </div>
          </div>
          
          <!-- 选择设备但搜索后无数据时的提示 -->
          <div v-else-if="hasSearched && !selectedDeviceStats" class="no-data-prompt">
            <div class="prompt-content">
              <div class="prompt-icon">📈</div>
              <div class="prompt-text">当前设备暂无使用统计数据</div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <!-- 新增/编辑设备模态框 -->
    <div v-if="showDeviceModal" class="modal-overlay" @click.self="closeDeviceModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ isEditMode ? '编辑设备' : '新增设备' }}</h3>
          <span class="close-btn" @click="closeDeviceModal" role="button" aria-label="关闭">×</span>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveDevice" enctype="multipart/form-data">
            <!-- 设备ID（编辑模式时显示） -->
            <div class="form-group" v-if="isEditMode">
              <label for="deviceIdInput">设备ID：</label>
              <input id="deviceIdInput" 
                     type="text" 
                     :value="editingDeviceId" 
                     class="form-input-modal" 
                     disabled>
            </div>

            <div class="form-group">
              <label for="deviceNoInput">设备编号：</label>
              <input id="deviceNoInput" 
                     type="text" 
                     v-model="deviceForm.deviceNo" 
                     required 
                     class="form-input-modal" 
                     :disabled="isEditMode" 
                     placeholder="请输入设备编号">
            </div>

            <div class="form-group">
              <label for="deviceNameInput">设备名称：</label>
              <input id="deviceNameInput" 
                     type="text" 
                     v-model="deviceForm.deviceName" 
                     required 
                     class="form-input-modal" 
                     placeholder="请输入设备名称">
            </div>

            <!-- 设备洗衣二维码图片上传 -->
            <div class="form-group">
              <label>设备洗衣二维码：</label>
              <div class="upload-container">
                <!-- 图片预览（编辑模式时显示已有图片） -->
                <div v-if="washQRPreviewUrl" class="image-preview">
                  <img :src="washQRPreviewUrl" alt="洗衣二维码预览" class="preview-img">
                  <button type="button" class="remove-image" @click="removeImage('wash')" title="删除图片">×</button>
                </div>
                
                <!-- 上传按钮 -->
                <div class="upload-area" @click="triggerFileUpload('wash')">
                  <input 
                    type="file" 
                    ref="washFileInput"
                    accept="image/*"
                    style="display: none;"
                    @change="handleFileSelect($event, 'wash')"
                  >
                  <div class="upload-placeholder">
                    <span class="upload-icon">📤</span>
                    <span>{{ washQRPreviewUrl ? '重新选择图片' : '点击上传图片' }}</span>
                    <span class="upload-hint">支持jpg、png格式，最大5MB</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 设备取衣二维码图片上传 -->
            <div class="form-group">
              <label>设备取衣二维码：</label>
              <div class="upload-container">
                <!-- 图片预览（编辑模式时显示已有图片） -->
                <div v-if="takeQRPreviewUrl" class="image-preview">
                  <img :src="takeQRPreviewUrl" alt="取衣二维码预览" class="preview-img">
                  <button type="button" class="remove-image" @click="removeImage('take')" title="删除图片">×</button>
                </div>
                
                <!-- 上传按钮 -->
                <div class="upload-area" @click="triggerFileUpload('take')">
                  <input 
                    type="file" 
                    ref="takeFileInput"
                    accept="image/*"
                    style="display: none;"
                    @change="handleFileSelect($event, 'take')"
                  >
                  <div class="upload-placeholder">
                    <span class="upload-icon">📤</span>
                    <span>{{ takeQRPreviewUrl ? '重新选择图片' : '点击上传图片' }}</span>
                    <span class="upload-hint">支持jpg、png格式，最大5MB</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 服务状态 -->
            <div class="form-group">
              <label for="serviceStatusSelect">服务状态：</label>
              <select id="serviceStatusSelect" 
                      v-model="deviceForm.serviceStatus" 
                      class="form-input-modal">
                <option value="">请选择（默认为正常）</option>
                <option v-for="status in serviceStatusOptions" 
                        :key="status.value" 
                        :value="status.value">
                  {{ status.label }}
                </option>
              </select>
            </div>

            <!-- 安装位置 -->
            <div class="form-group">
              <label for="locationSelect">安装位置：</label>
              <input id="locationSelect" 
                     type="text" 
                     v-model="deviceForm.location" 
                     class="form-input-modal" 
                     placeholder="请输入安装位置"
                     required>
            </div>

            <!-- 安装时间 -->
            <div class="form-group">
              <label for="installTimeInput">安装时间：</label>
              <input id="installTimeInput" 
                     type="date" 
                     v-model="deviceForm.installTime" 
                     class="form-input-modal">
            </div>

            <div class="modal-footer">
              <button type="button" class="btn-cancel" @click="closeDeviceModal">取消</button>
              <button type="submit" class="btn-confirm" :disabled="submitting">{{ isEditMode ? '保存' : '创建' }}</button>
            </div>

          </form>
        </div>
      </div>
    </div>

    <!-- 故障处理模态框 -->
    <div v-if="showFaultModal" class="modal-overlay" @click.self="closeFaultModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>处理故障</h3>
          <span class="close-btn" @click="closeFaultModal" role="button" aria-label="关闭">×</span>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveFaultHandle">
            <div class="form-group">
              <label>设备编号：</label>
              <input type="text" v-model="faultForm.deviceNo" class="form-input-modal" disabled>
            </div>
            <div class="form-group">
              <label>当前状态：</label>
              <input type="text" v-model="faultForm.currentStatusName" class="form-input-modal" disabled>
            </div>
            <div class="form-group">
              <label for="handleStatusSelect">修改为：</label>
              <select id="handleStatusSelect" 
                      v-model="faultForm.handleStatus" 
                      class="form-input-modal" 
                      required>
                <option value="">请选择处理状态</option>
                <option value="PROCESSING">处理中</option>
                <option value="RESOLVED">已处理</option>
              </select>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn-cancel" @click="closeFaultModal">取消</button>
              <button type="submit" class="btn-confirm" >确认处理</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 导出单报表模态框 -->
    <div v-if="showExportReportModal" class="modal-overlay" @click.self="closeExportReportModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>单设备导出报表</h3>
          <span class="close-btn" @click="closeExportReportModal" role="button" aria-label="关闭">×</span> 
        </div>
        <div class="modal-body">
          <form @submit.prevent="handleExportReport">

            <div class="form-group">
              <label for="deviceIdInput">设备ID：</label>
              <select id="deviceIdInput" 
                      v-model="reportForm.deviceId" 
                      class="form-input-modal" 
                      required>
                <option value="">请选择设备ID</option>
                <option v-for="device in statsDeviceOptions" 
                        :key="device.deviceId" 
                        :value="device.deviceId">
                  {{ device.deviceName || device.deviceNo }} (ID: {{ device.deviceId }})
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="reportTypeSelect">报表类型：</label>
              <select id="reportTypeSelect" 
                      v-model="reportForm.reportType" 
                      class="form-input-modal" 
                      required>
                <option value="">请选择报表类型</option>
                <option v-for="type in reportTypeOptions" 
                        :key="type.value" 
                        :value="type.value">
                  {{ type.label }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="exportFormatSelect">导出格式：</label>
              <select id="exportFormatSelect" 
                      v-model="reportForm.exportFormat" 
                      class="form-input-modal" 
                      required>
                <option value="">请选择导出格式</option>
                <option value="EXCEL">EXCEL</option>
                <option value="CSV">CSV</option>
              </select>
            </div>

            <div class="form-group">
              <label for="startDateInput">起始日期：</label>
              <input id="startDateInput" 
                     type="date" 
                     v-model="reportForm.startDate" 
                     required
                     class="form-input-modal">
            </div>

            <div class="form-group">  
              <label for="endDateInput">结束日期：</label>
              <input id="endDateInput" 
                     type="date" 
                     v-model="reportForm.endDate" 
                     required
                     class="form-input-modal">
            </div>

            <div class="modal-footer">
              <button type="button" class="btn-cancel" @click="closeExportReportModal">取消</button>
              <button type="submit" class="btn-confirm">确认导出</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 导出多报表模态框 -->
    <div v-if="showMultExportReportModal" class="modal-overlay" @click.self="closeMultExportReportModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>多设备导出报表</h3>
          <span class="close-btn" @click="closeMultExportReportModal" role="button" aria-label="关闭">×</span>
        </div>
        <div class="modal-body">
          <form @submit.prevent="handleMultExportReport">

            <div class="form-group">
              <label for="deviceIdsInput">设备ID：</label>
              <select id="deviceIdsInput" 
                      v-model="multReportForm.deviceIds" 
                      class="form-input-modal" 
                      required
                      multiple
                      size="5">
                <option v-for="device in statsDeviceOptions" 
                        :key="device.deviceId" 
                        :value="device.deviceId">
                  {{ device.deviceName || device.deviceNo }} (ID: {{ device.deviceId }})
                </option>
              </select>
              <div class="form-hint">按住Ctrl键多选</div>
            </div>

            <div class="form-group">
              <label for="multReportTypeSelect">报表类型：</label>
              <select id="multReportTypeSelect" 
                      v-model="multReportForm.reportType" 
                      class="form-input-modal" 
                      required>
                <option value="">请选择报表类型</option>
                <option v-for="type in reportTypeOptions" 
                        :key="type.value" 
                        :value="type.value">
                  {{ type.label }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="multExportFormatSelect">导出格式：</label>
              <select id="multExportFormatSelect" 
                      v-model="multReportForm.exportFormat" 
                      class="form-input-modal" 
                      required>
                <option value="">请选择导出格式</option>
                <option value="EXCEL">EXCEL</option>
                <option value="CSV">CSV</option>
              </select>
            </div>

            <div class="form-group">
              <label for="multStartDateInput">起始日期：</label>
              <input id="multStartDateInput" 
                     type="date" 
                     v-model="multReportForm.startDate" 
                     required
                     class="form-input-modal">
            </div>

            <div class="form-group">  
              <label for="multEndDateInput">结束日期：</label>
              <input id="multEndDateInput"  
                     type="date" 
                     v-model="multReportForm.endDate" 
                     required
                     class="form-input-modal">      
            </div>

            <div class="modal-footer">  
              <button type="button" class="btn-cancel" @click="closeMultExportReportModal">取消</button>
              <button type="submit" class="btn-confirm">确认导出</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 图片预览模态框 -->
    <div v-if="showImagePreview" class="modal-overlay" @click.self="closeImagePreview">
      <div class="image-preview-container" @click="closeImagePreview">
        <div class="image-preview-content">
          <img 
            :src="previewImageUrl" 
            alt="图片预览"
            class="preview-image"
            @click.stop
          >
          <div class="image-preview-tools">
            <button class="preview-close-btn" @click="closeImagePreview">关闭</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EchartsDoughnutPieChart from '@/components/EchartsDoughnutPieChart.vue';
import EchartsBarChart from '@/components/EchartsBarChart.vue';
// 导入工具函数
import { downloadFile } from '@/api/download';
import { validateDateRange } from '@/api/dateValidator';
import { 
  listDevices,
  getDeviceDetail,
  addDevice,
  updateDevice,
  deleteDevice,
  listDeviceFaults,
  handleDeviceFault,
  exportDeviceReport,
  getDeviceUsageReport
} from '@/api/laundry';

export default {
  name: 'LaundryDeviceManagement',

  components: {
    EchartsDoughnutPieChart,
    EchartsBarChart
  },

  data() {
    return {
      // 图片预览相关
      showImagePreview: false,
      previewImageUrl: '',
      
      // 图片上传相关
      washQRFile: null,        // 洗衣二维码文件
      takeQRFile: null,        // 取衣二维码文件
      washQRPreviewUrl: '',    // 洗衣二维码预览URL
      takeQRPreviewUrl: '',    // 取衣二维码预览URL
      submitting: false,       // 提交状态
      
      // 状态枚举（与接口文档一致）
      serviceStatusOptions: [
        { label: '正常', value: 'NORMAL' },
        { label: '离线', value: 'OFFLINE' },
        { label: '故障', value: 'FAULT' },
        { label: '维护中', value: 'MAINTENANCE' }
      ],
      handleStatusOptions: [
        { label: '待处理', value: 'PENDING' },
        { label: '已处理', value: 'RESOLVED' },
        { label: '处理中', value: 'PROCESSING' }
      ],

      reportTypeOptions: [
        { label: '使用统计报表', value: 'USAGE' },
        { label: '故障报表', value: 'FAULT' },
        { label: '综合报表', value: 'MAINTENANCE' }
      ],
      
      // 接口动态加载的选项
      deviceOptions: [], // 设备编号选项（从设备列表提取）
      locationOptions: [], // 安装位置选项（从设备列表提取）
      faultdeviceOptions: [], // 故障设备列表选项（从故障列表提取）
      faultlocationOptions: [], // 故障设备位置选项（从故障列表提取）
      statsDeviceOptions: [], // 使用统计设备选项（从设备列表提取）
      
      // 接口返回数据
      deviceList: [], // 设备列表
      deviceTotal: 0, // 设备总条数

      faultList: [], // 故障列表
      faultTotal: 0, // 故障总条数

      usageStats: [], // 使用统计数据
      selectedDeviceStats: null, // 选中的设备统计数据
      
      // 页面Tab
      tabs: [
        { label: '设备信息' },
        { label: '故障统计' },
        { label: '使用统计' }
      ],
      activeTab: '设备信息',
      loading: false,
      pageInput: '',// 页码输入框
      faultPageInput: '',// 故障页码输入框
      
      // 设备查询参数
      query: {
        deviceNo: '',
        location: '',
        serviceStatus: '',
        installDate: '',
        pageNo: 1, // 页码（从1开始）
        pageSize: 10 // 每页条数
      },

      // 故障查询参数
      faultQuery: {
        deviceNo: '',
        location: '',
        handleStatus: '',
        pageNo: 1,
        pageSize: 10
      },
      
      // 使用统计查询参数
      statsQuery: {
        deviceId: ''
      },
      
      // 分离日期输入
      startDateInput: '',  // 用于 v-model="startDateInput"
      endDateInput: '',    // 用于 v-model="endDateInput"
      faultStartDate: '',  // 实际发送到接口的日期（YYYY/MM/DD格式）
      faultEndDate: '',    // 实际发送到接口的日期（YYYY/MM/DD格式）
      
      // 设备新增/编辑模态框
      showDeviceModal: false,// 是否显示模态框
      isEditMode: false,// 是否为编辑模式
      editingDeviceId: '',// 正在编辑的设备ID
      deviceForm: {
        deviceNo: '',
        deviceName: '',
        serviceStatus: '',
        location: '',
        installTime: ''
      },
      
      // 故障处理模态框
      showFaultModal: false,// 是否显示模态框
      faultForm: {
        faultId: '',// 故障ID
        deviceNo: '',// 设备编号
        faultDescription: '',// 故障原因
        currentStatus: '',// 当前状态
        currentStatusName: '',// 当前状态名称
        handleStatus: ''
      },

      // 导出单报表模态框
      showExportReportModal: false, // 是否显示模态框
      reportForm:{
        deviceIds: '',
        startDate: '',
        endDate: '',
        reportType: '',
        exportFormat: ''
      },

      // 导出多报表模态框
      showMultExportReportModal: false, // 是否显示多设备导出报表模态框
      multReportForm: {
        deviceIds: [],
        startDate: '',
        endDate: '',
        reportType: '',
        exportFormat: ''
      },

      // 新增：跟踪是否执行了搜索
      hasSearched: false,
      
      // 导出相关的状态
      exportLoading: false,
      
    }
  },

  computed: {
    // 检查查询的时间范围是否有效
    isQueryValid() {
      return this.startDateInput && this.endDateInput;
    },

    // 设备列表安装日期的计算属性
    installDateForInput: {
      get() {
        // 将存储的 YYYY/MM/DD 格式转换为输入框需要的 YYYY-MM-DD 格式
        if (!this.query.installDate) return '';
        return this.query.installDate.replace(/\//g, '-');
      },
      set(value) {
        // 将输入框的 YYYY-MM-DD 格式转换为存储的 YYYY/MM/DD 格式
        if (!value) {
          this.query.installDate = '';
        } else {
          this.query.installDate = value.replace(/-/g, '/');
        }
      }
    },
  },

  // 生命周期函数
  async mounted() {
    await this.loadAllDeviceNos(); // 加载设备编号选项和位置选项
    await this.loadFaultDeviceOptions(); // 加载故障设备选项
    await this.fetchAllData();// 加载所有数据
  },

  methods: {
    // 获取所有数据
    async fetchAllData() {
      this.loading = true;
      try {
        const startTime = new Date().getTime(); // 开始时间戳

        // 等待所有接口调用完成
        await Promise.allSettled([
          this.loadDeviceData(), // 获取设备信息列表数据
          this.loadFaultData(), // 获取故障统计列表数据
          this.loadDeviceOptionsForStats() // 加载使用统计的设备选项
        ]);
        
        const endTime = new Date().getTime();
        console.log(`设备管理模块数据更新完成，耗时：${endTime - startTime}ms`);
        
      } catch (error) {
        console.error('设备管理模块数据更新全局异常:', error);
        this.showMessage('设备管理模块数据更新异常，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    // 加载设备信息页面中的→设备选项和位置选项
    async loadAllDeviceNos() {
      try {
        // 调用接口获取全部设备（不分页）
        const response = await listDevices({
          pageNo: 1,
          pageSize: 100 // 设置一个很大的值，获取全部设备
        });
        const res = response.data;
        
        if (res.code === 0 && res.data && res.data.list) {
          const allDevices = res.data.list;
          
          // 提取所有不重复的设备编号
          const allNos = [...new Set(allDevices.map(item => item.deviceNo))];
          this.deviceOptions = allNos.map(no => ({ deviceNo: no }));
          
          // 提取所有不重复的安装位置
          this.locationOptions = [...new Set(allDevices.map(item => item.location))].filter(loc => loc);
          
          console.log(`已加载全部设备编号：${this.deviceOptions.length}个，全部安装位置：${this.locationOptions.length}个`);
        }
      } catch (error) {
        console.error('加载全部设备编号和安装位置失败:', error);
        // 失败时至少用当前页的数据
        this.deviceOptions = [...new Set(this.deviceList.map(item => item.deviceNo))].map(no => ({ deviceNo: no }));
        this.locationOptions = [...new Set(this.deviceList.map(item => item.location))].filter(loc => loc);
      }
    },
    
    // 加载故障统计页面中的→故障设备选项
    async loadFaultDeviceOptions() {
      try {
        // 调用接口获取全部故障（不分页）
        const response = await listDeviceFaults({
          pageNo: 1,
          pageSize: 100 // 设置一个很大的值，获取全部故障
        });
        const res = response.data;
        
        if (res.code === 0 && res.data && res.data.list) {
          const allFaults = res.data.list;
          // 提取所有不重复的故障设备编号
          const allNos = [...new Set(allFaults.map(item => item.deviceNo))]; 
          this.faultdeviceOptions = allNos.map(no => ({ deviceNo: no }));
          const allLocations = [...new Set(allFaults.map(item => item.location))].filter(loc => loc );
          this.faultlocationOptions =allLocations ;
          
          console.log(`已加载全部故障设备编号：${this.faultdeviceOptions.length}个，全部故障设备位置：${this.faultlocationOptions.length}个`)
        }
      } catch (error) {
        console.error('加载全部故障设备编号失败:', error);
        // 失败时至少用当前页的数据
        this.faultdeviceOptions = [...new Set(this.faultList.map(item => item.deviceNo))].map(no => ({ deviceNo: no }));
        this.faultlocationOptions = [...new Set(this.faultList.map(item => item.location))].filter(loc => loc);
      }
    },

    // ---------------------- 接口获取数据相关方法 ----------------------
    // 获取设备信息列表数据
    async loadDeviceData() {
      this.loading = true;
      try {
        const response = await listDevices(this.query);
        const res = response.data;
        
        if (res.code === 0 ) {
          this.deviceList = res.data.list || [];
          this.deviceTotal = res.data.total || 0;
        } else {
          this.deviceList = [];
          this.deviceTotal = 0;
          this.showMessage('设备数据加载异常', 'warning');
        }
      } catch (error) {
        console.error('加载设备数据失败:', error);
        this.deviceList = [];
        this.deviceTotal = 0;
        this.showMessage('设备数据加载失败', 'warning');
      } finally {
        this.loading = false;
      }
    },

    // 加载使用统计的设备选项
    async loadDeviceOptionsForStats() {
      try {
        // 使用设备列表的查询条件，但获取全部设备用于下拉选项
        const params = {
          pageNo: 1,
          pageSize: 100 // 获取足够多的设备用于选择
        };
        
        const response = await listDevices(params);
        const res = response.data;
        
        if (res.code === 0 && res.data && res.data.list) {
          this.statsDeviceOptions = res.data.list.map(device => ({
            deviceId: device.deviceId,
            deviceNo: device.deviceNo,
            deviceName: device.deviceName,
            location: device.location
          }));
        } else {
          this.statsDeviceOptions = [];
        }
      } catch (error) {
        console.error('加载使用统计设备选项失败:', error);
        this.statsDeviceOptions = [];
      }
    },

    // 获取设备详情数据（编辑回显）
    async loadDeviceDetail(deviceId) {
      if (!deviceId) return false;
      try {
        const response = await getDeviceDetail(deviceId);
        const res = response.data;
        console.log('设备详情数据（编辑回显）：', res);
        
        if (res.code === 0 && res.data) {
          const device = res.data;
          
          // 处理安装时间
          let installTime = '';
          if (device.installTime) {
            // 假设返回格式为 "2024/01/15" 或 "2024-01-15"
            installTime = device.installTime.includes('/') 
              ? device.installTime.replace(/\//g, '-') 
              : device.installTime;
          }
          
          this.deviceForm = {
            deviceNo: device.deviceNo || '',
            deviceName: device.deviceName || '',
            serviceStatus: device.serviceStatus || '',
            location: device.location || '',
            installTime: installTime
          };
          
          // 设置图片预览（使用返回的URL）
          if (device.washQRCodeImageUrl) {
            this.washQRPreviewUrl = device.washQRCodeImageUrl;
          }
          if (device.takeQRCodeImageUrl) {
            this.takeQRPreviewUrl = device.takeQRCodeImageUrl;
          }
          
          this.isEditMode = true;
          this.editingDeviceId = deviceId;
          return true;
        } else {
          this.showMessage('设备详情数据加载失败：' + (res.msg || '无数据'), 'error');
          this.resetDeviceForm();
          return false;
        }
      } catch (error) {
        console.error('加载设备详情数据失败:', error);
        this.showMessage('设备详情数据加载失败：网络异常', 'error');
        this.resetDeviceForm();
        return false;
      }
    },

    // 新增设备
    async addDeviceAction(formData) {
      try {
        console.log('新增设备 - 使用FormData');
        
        // 遍历FormData查看内容（调试用）
        for (let pair of formData.entries()) {
          console.log(pair[0] + ': ' + (pair[1] instanceof File ? pair[1].name : pair[1]));
        }
        
        const response = await addDevice(formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        const res = response.data;
        if (res.code === 0) {
          this.showMessage('设备新增成功', 'success');
          this.closeDeviceModal();
          await this.loadDeviceData(); // 刷新列表
          await this.loadAllDeviceNos(); // 重新加载设备选项
        } else {
          this.showMessage('设备新增失败：' + (res.msg || '未知错误'), 'error');
        }
      } catch (error) {
        console.error('新增设备失败:', error);
        throw error;
      }
    },

    // 编辑保存
    async updateDeviceAction(formData) {
      if (!this.editingDeviceId) return;
      
      try {
        console.log('更新设备 - 使用FormData');
        
        // 遍历FormData查看内容（调试用）
        for (let pair of formData.entries()) {
          console.log(pair[0] + ': ' + (pair[1] instanceof File ? pair[1].name : pair[1]));
        }
        
        const response = await updateDevice(formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        const res = response.data;
        if (res.code === 0) {
          this.showMessage('设备更新成功', 'success');
          this.closeDeviceModal();
          await this.loadDeviceData(); // 刷新列表
          await this.loadAllDeviceNos(); // 重新加载设备选项
        } else {
          this.showMessage('设备更新失败：' + (res.msg || '未知错误'), 'error');
        }
      } catch (error) {
        console.error('更新设备失败:', error);
        throw error;
      }
    },

    // 删除设备
    async onDelete(item) {
      if (!item.deviceId) return;
      if (!confirm(`确定要删除设备【${item.deviceId}】吗？`)) return;
      this.loading = true;
      
      try {
        const data = {
          deviceId: item.deviceId
        };
        
        const response = await deleteDevice(data);
        const res = response.data;
        
        if (res.code === 0) {
          this.showMessage('设备删除成功', 'success');
          await this.loadDeviceData();
          await this.loadAllDeviceNos(); // 重新加载设备选项
        } else {
          this.showMessage('设备删除失败：' + (res.msg || '未知错误'), 'error');
        }
      } catch (error) {
        console.error('删除设备失败详情：', error);
        
        // 更详细的错误信息
        if (error.response) {
          console.error('服务器响应数据：', error.response.data);
          console.error('状态码：', error.response.status);
          
          let errorMsg = '删除失败：服务器错误';
          if (error.response.data) {
            if (error.response.data.msg) {
              errorMsg = `删除失败：${error.response.data.msg}`;
            } else if (error.response.data.message) {
              errorMsg = `删除失败：${error.response.data.message}`;
            }
          }
          this.showMessage(errorMsg, 'error');
        } else if (error.request) {
          console.error('请求已发出但无响应');
          this.showMessage('删除失败：网络连接错误，请检查网络', 'error');
        } else {
          console.error('请求配置错误：', error.message);
          this.showMessage(`删除失败：${error.message}`, 'error');
        }
      } finally {
        this.loading = false;
      }
    },

    // 获取使用统计数据
    async loadUsageStatistics(deviceId) {
      this.statsQuery.deviceId = deviceId;
      console.log('使用统计查询参数：', this.statsQuery.deviceId);
      this.loading = true;
      try {
        const response = await getDeviceUsageReport(this.statsQuery.deviceId);
        const res = response.data;
        if (res.code === 0) {
          // 构建选中设备的统计数据
          this.selectedDeviceStats = {
            deviceName: '',
            deviceId: '',
            basicStats: {
              usageDurationDays: 0,
              usageCount: 0,
            },
            faultRate: {
              faultCount: 0,
              normalCount: 0
            },
            faultHandleStats: {
              resolvedCount: 0,
              pendingCount: 0,
              processingCount: 0
            },
            usageTimeChart: {
              timePoints: [],
              orderCounts: []
            }
          };
          
          // 从返回的数据中查找选中的设备
          if (res.data.devices && res.data.devices.length > 0) {
            this.selectedDeviceStats.deviceName = res.data.devices[0].deviceName;
            this.selectedDeviceStats.deviceId = res.data.devices[0].deviceId;

            this.selectedDeviceStats.basicStats.usageDurationDays = res.data.devices[0].basicStats?.usageDurationDays || 0;
            this.selectedDeviceStats.basicStats.usageCount = res.data.devices[0].basicStats?.usageCount || 0;

            this.selectedDeviceStats.faultRate.faultCount = res.data.devices[0].faultRate?.faultCount || 0;
            this.selectedDeviceStats.faultRate.normalCount = res.data.devices[0].faultRate?.normalCount || 0;
            
            this.selectedDeviceStats.faultHandleStats.resolvedCount = res.data.devices[0].faultHandleStats?.resolvedCount || 0;
            this.selectedDeviceStats.faultHandleStats.pendingCount = res.data.devices[0].faultHandleStats?.pendingCount || 0;
            this.selectedDeviceStats.faultHandleStats.processingCount = res.data.devices[0].faultHandleStats?.processingCount || 0;

            this.selectedDeviceStats.usageTimeChart.timePoints = res.data.devices[0].usageTimeChart?.timePoints || [];
            this.selectedDeviceStats.usageTimeChart.orderCounts = res.data.devices[0].usageTimeChart?.orderCounts || [];
          }
          
          console.log('选中的设备统计数据：', this.selectedDeviceStats);
        } else {
          this.selectedDeviceStats = null;
          this.showMessage('使用统计数据加载失败：' + (res.msg || '未知错误'), 'error');
        }
      } catch (error) {
        console.error('加载使用统计数据失败:', error);
        this.selectedDeviceStats = null;
        this.showMessage('使用统计数据加载失败：网络异常', 'error');
      } finally {
        this.loading = false;
      }
    },

    // 获取故障统计列表数据
    async loadFaultData() {
      this.faultStartDate = this.startDateInput ? this.startDateInput.replace(/-/g, '/') : '';
      this.faultEndDate = this.endDateInput ? this.endDateInput.replace(/-/g, '/') : '';
        
      // 构建查询参数
      const params = {
        install_location: this.faultQuery.location,
        deviceNo: this.faultQuery.deviceNo,
        startDate: this.faultStartDate,
        endDate: this.faultEndDate,
        handleStatus: this.faultQuery.handleStatus,
        pageNo: this.faultQuery.pageNo,
        pageSize: this.faultQuery.pageSize
      };
      this.loading = true;
      try {
        // 构建查询参数
        console.log('发送到接口的故障查询参数：', params);
        
        const response = await listDeviceFaults(params);
        const res = response.data;

        if (res.code === 0) {
          this.faultList = res.data.list || [];
          this.faultTotal = res.data.total || 0;
        } else {
          this.faultList = [];
          this.faultTotal = 0;
          this.showMessage('故障数据加载异常', 'warning');
        }
      } catch (error) {
        console.error('加载故障数据失败:', error);
        this.faultList = [];
        this.faultTotal = 0;
        this.showMessage('故障数据加载失败', 'warning');
      } finally {
        this.loading = false;
      }
    },
    
    // 处理故障
    async handleFaultAction(data) {
      try {
        const response = await handleDeviceFault(data);
        const res = response.data;
        
        if (res.code === 0) {
          // 显示成功消息
          this.showMessage('故障处理成功!', 'success');
          
          // 等待1秒让用户看到成功消息，然后刷新
          setTimeout(() => {
            this.loadFaultData();
          }, 1000);
          
        } else {
          this.showMessage('故障处理失败：' + (res.msg || '未知错误'), 'error');
        }
      } catch (error) {
        console.error('处理故障失败:', error);
        this.showMessage('故障处理失败：网络异常', 'error');
      }
    },

    // 导出单个设备报表
    async exportDeviceReportAction(params) {
      this.closeExportReportModal();
      try {
        // 构建导出参数
        const exportParams = {
          deviceId: params.deviceId,
          startDate: params.startDate ? params.startDate.replace(/-/g, '/') : '',
          endDate: params.endDate ? params.endDate.replace(/-/g, '/') : '',
          reportType: params.reportType,
          exportFormat: params.exportFormat
        };
        
        console.log('导出报表参数：', exportParams);
        
        const response = await exportDeviceReport(exportParams);
        const res = response.data;
        console.log('导出报表响应数据：', res);
        
        if (res.code === 0 && res.data) {
          this.showMessage('报表导出成功，开始下载', 'success');
          
          // 使用downloadFile工具下载文件
          if (res.data.fileUrl) {
            downloadFile(res.data.fileUrl, res.data.fileName, res.data.expiresAt);
          } else if (res.data.url) {
            window.open(res.data.url);
          } else {
            this.showMessage('导出成功，但未找到下载链接', 'warning');
          }
        } else {
          this.showMessage('报表导出失败：' + (res.msg || '未知错误'), 'error');
        }
      } catch (error) {
        console.error('导出设备报表失败:', error);
        
        let errorMsg = '报表导出失败';
        if (error.response) {
          if (error.response.data && error.response.data.msg) {
            errorMsg = `报表导出失败：${error.response.data.msg}`;
          }
        }
        this.showMessage(errorMsg, 'error');
      }
    },
    
    // 导出多个设备报表
    async exportMultDeviceReportAction(params) {
      this.closeMultExportReportModal();
      try {
        // 构建导出参数
        const exportParams = {
          deviceIds: params.deviceIds.join(','),
          startDate: params.startDate ? params.startDate.replace(/-/g, '/') : '',
          endDate: params.endDate ? params.endDate.replace(/-/g, '/') : '',
          reportType: params.reportType,
          format: params.exportFormat
        };
        
        console.log('导出报表参数：', exportParams);
        
        const response = await exportDeviceReport(exportParams);
        const res = response.data;
        console.log('导出报表响应数据：', res);
        
        if (res.code === 0 && res.data) {
          this.showMessage('报表导出成功，开始下载', 'success');
          
          // 使用downloadFile工具下载文件
          if (res.data.fileUrl) {
            downloadFile(res.data.fileUrl, res.data.fileName, res.data.expiresAt);
          } else if (res.data.url) {
            window.open(res.data.url);
          } else {
            this.showMessage('导出成功，但未找到下载链接', 'warning');
          }
        } else {
          this.showMessage('报表导出失败：' + (res.msg || '未知错误'), 'error');
        }
      } catch (error) {
        console.error('导出设备报表失败:', error);
        
        let errorMsg = '报表导出失败';
        if (error.response) {
          if (error.response.data && error.response.data.msg) {
            errorMsg = `报表导出失败：${error.response.data.msg}`;
          }
        }
        this.showMessage(errorMsg, 'error');
      }
    },

    // ---------------------- 图片上传相关方法 ----------------------
    
    // 触发文件上传
    triggerFileUpload(type) {
      if (type === 'wash') {
        this.$refs.washFileInput.click();
      } else if (type === 'take') {
        this.$refs.takeFileInput.click();
      }
    },

    // 处理文件选择
    handleFileSelect(event, type) {
      const file = event.target.files[0];
      if (!file) return;
      
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.showMessage('请选择图片文件', 'warning');
        return;
      }
      
      // 验证文件大小（限制为5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.showMessage('图片大小不能超过5MB', 'warning');
        return;
      }
      
      // 创建预览URL
      const previewUrl = URL.createObjectURL(file);
      
      if (type === 'wash') {
        // 如果之前有预览URL，需要释放
        if (this.washQRPreviewUrl && !this.washQRPreviewUrl.startsWith('http')) {
          URL.revokeObjectURL(this.washQRPreviewUrl);
        }
        this.washQRFile = file;
        this.washQRPreviewUrl = previewUrl;
      } else if (type === 'take') {
        if (this.takeQRPreviewUrl && !this.takeQRPreviewUrl.startsWith('http')) {
          URL.revokeObjectURL(this.takeQRPreviewUrl);
        }
        this.takeQRFile = file;
        this.takeQRPreviewUrl = previewUrl;
      }
    },

    // 删除图片
    removeImage(type) {
      if (type === 'wash') {
        if (this.washQRPreviewUrl && !this.washQRPreviewUrl.startsWith('http')) {
          URL.revokeObjectURL(this.washQRPreviewUrl);
        }
        this.washQRFile = null;
        this.washQRPreviewUrl = '';
        if (this.$refs.washFileInput) {
          this.$refs.washFileInput.value = '';
        }
      } else if (type === 'take') {
        if (this.takeQRPreviewUrl && !this.takeQRPreviewUrl.startsWith('http')) {
          URL.revokeObjectURL(this.takeQRPreviewUrl);
        }
        this.takeQRFile = null;
        this.takeQRPreviewUrl = '';
        if (this.$refs.takeFileInput) {
          this.$refs.takeFileInput.value = '';
        }
      }
    },

    // ---------------------- 单设备导出报表相关方法 ----------------------
    
    // 打开单个"导出"报表模态框
    openExportReportModal() {
      // 初始化报表表单
      this.reportForm = {
        deviceIds: this.statsQuery.deviceId || '', // 如果有已选的设备ID，就预填上
        startDate: '',
        endDate: '',
        reportType: '',
        exportFormat: ''
      };
      
      this.showExportReportModal = true;
    },

    // 关闭单个"导出"报表模态框
    closeExportReportModal() {
      this.showExportReportModal = false;
      this.reportForm = {
        deviceIds: '',
        startDate: '',
        endDate: '',
        reportType: '',
        exportFormat: ''
      };
    },

    // 处理单设备"导出"报表确认
    async handleExportReport() {
      // 验证必填项
      if (!this.reportForm.deviceIds) {
        this.showMessage('请选择设备ID', 'warning');
        return;
      }
      
      if (!this.reportForm.startDate || !this.reportForm.endDate) {
        this.showMessage('请选择起始日期和结束日期', 'warning');
        return;
      }
      
      if (!this.reportForm.reportType) {
        this.showMessage('请选择报表类型', 'warning');
        return;
      }
      
      if (!this.reportForm.exportFormat) {
        this.showMessage('请选择导出格式', 'warning');
        return;
      }
      
      // 验证日期范围
      const query = {
        startDate: this.reportForm.startDate,
        endDate: this.reportForm.endDate
      };
      
      const isValid = validateDateRange(
        query,
        this.showMessage,
        365
      );
      
      if (!isValid) {
        this.showMessage('日期选择无效，请重新选择', 'warning');
        return;
      }
      
      // 执行导出
      await this.exportDeviceReportAction(this.reportForm);
    },

    // 单设备使用统计报表导出（卡片上的导出按钮）
    async exportSingleDeviceReport() {
      if (!this.statsQuery.deviceId) {
        this.showMessage('请先选择要导出的设备', 'warning');
        return;
      }
      
      // 初始化报表表单，预填当前选中的设备ID
      this.reportForm = {
        deviceIds: this.statsQuery.deviceId,
        startDate: '',
        endDate: '',
        reportType: 'USAGE',
        exportFormat: 'EXCEL'
      };
      this.showExportReportModal = true;
    },

    // ---------------------- 多设备导出报表相关方法 ----------------------
    // 打开"导出"报表模态框（多设备）
    openMultExportReportModal() {
      // 初始化报表表单
      this.multReportForm = {
        deviceIds: [], 
        startDate: '',
        endDate: '',
        reportType: '',
        exportFormat: ''
      };
      
      this.showMultExportReportModal = true;
    },

    // 关闭"导出"报表模态框（多设备）
    closeMultExportReportModal() {
      this.showMultExportReportModal = false;
      this.multReportForm = {
        deviceIds: [], 
        startDate: '',
        endDate: '',
        reportType: '',
        exportFormat: ''
      };
    },
    
    // 处理多设备"导出"报表确认
    async handleMultExportReport() {
      // 验证必填项
      if (!this.multReportForm.deviceIds || this.multReportForm.deviceIds.length === 0) {
        this.showMessage('请选择设备ID', 'warning');
        return;
      }
      
      if (!this.multReportForm.startDate || !this.multReportForm.endDate) {
        this.showMessage('请选择起始日期和结束日期', 'warning');
        return;
      }
      
      if (!this.multReportForm.reportType) {
        this.showMessage('请选择报表类型', 'warning');
        return;
      }
      
      if (!this.multReportForm.exportFormat) {
        this.showMessage('请选择导出格式', 'warning');
        return;
      }
      
      // 验证日期范围
      const query = {
        startDate: this.multReportForm.startDate,
        endDate: this.multReportForm.endDate
      };
      
      const isValid = validateDateRange(
        query,
        this.showMessage,
        365
      );
      
      if (!isValid) {
        this.showMessage('日期选择无效，请重新选择', 'warning');
        return;
      }
      
      // 执行导出
      await this.exportMultDeviceReportAction(this.multReportForm);
    },

    // 多设备使用统计报表导出（筛选条件中的导出按钮）
    async exportMultDeviceReport() {
      if (!this.statsQuery.deviceId) {
        this.showMessage('请先选择要导出的设备', 'warning');
        return;
      }
      
      // 初始化报表表单，预填当前选中的设备ID
      this.multReportForm = {
        deviceIds: [this.statsQuery.deviceId],
        startDate: '',
        endDate: '',
        reportType: 'USAGE',
        exportFormat: 'EXCEL'
      };
      this.showMultExportReportModal = true;
    },

    // ---------------------- 图片预览相关方法 ----------------------
    
    // 预览图片
    previewImage(imageUrl) {
      if (!imageUrl) return;
      this.previewImageUrl = imageUrl;
      this.showImagePreview = true;
      
      // 阻止页面滚动
      document.body.style.overflow = 'hidden';
    },
    
    // 关闭图片预览
    closeImagePreview() {
      this.showImagePreview = false;
      this.previewImageUrl = '';
      
      // 恢复页面滚动
      document.body.style.overflow = 'auto';
    },

    // ---------------------- 设备信息页面核心方法 ----------------------
    
    // 服务状态显示文本映射
    getServiceStatusShowText(item) {
      if (item.serviceStatusName === 'Normal'||item.serviceStatusName === '正常') {
        return '正常';
      }
      if (item.serviceStatusName === 'Offline'||item.serviceStatusName === '离线') {
        return '离线';
      }
      if (item.serviceStatusName === 'Fault'||item.serviceStatusName === '故障') {
        return '故障';
      }
      if (item.serviceStatusName === 'Maintenance'||item.serviceStatusName === '维护中') {
        return '维护中';
      }
      return '--';
    },


    // 保存设备信息
    async saveDevice() {
      this.submitting = true;
      
      try {
        // 创建 FormData 对象
        const formData = new FormData();
        
        // 添加基本字段
        if (this.deviceForm.deviceNo) {
          formData.append('deviceNo', this.deviceForm.deviceNo.trim());
        }
        
        if (this.deviceForm.deviceName) {
          formData.append('deviceName', this.deviceForm.deviceName.trim());
        }
        
        if (this.deviceForm.location) {
          formData.append('location', this.deviceForm.location.trim());
        }
        
        // 服务状态（非必填）
        if (this.deviceForm.serviceStatus) {
          formData.append('serviceStatus', this.deviceForm.serviceStatus.trim());
        }
        
        // 安装时间（转换为 yyyy/MM/dd 格式）
        if (this.deviceForm.installTime) {
          const installTime = this.deviceForm.installTime.replace(/-/g, '/');
          formData.append('installTime', installTime);
        }
        
        // 添加图片文件（如果选择了新图片）
        if (this.washQRFile) {
          formData.append('washQRCodeImage', this.washQRFile);
        }
        
        if (this.takeQRFile) {
          formData.append('takeQRCodeImage', this.takeQRFile);
        }
        
        // 如果是编辑模式，添加设备ID
        if (this.isEditMode && this.editingDeviceId) {
          formData.append('deviceId', this.editingDeviceId);
        }
        
        console.log('提交的表单数据：', formData);
        
        // 判断新增/编辑，调用对应方法
        if (this.isEditMode) {
          await this.updateDeviceAction(formData);
        } else {
          await this.addDeviceAction(formData);
        }
        
      } catch (error) {
        console.error('保存设备失败:', error);
        this.showMessage('保存失败：' + (error.message || '未知错误'), 'error');
      } finally {
        this.submitting = false;
      }
    },

    // 设备查询-搜索
    async onSearch() {
      this.query.pageNo = 1;
      this.pageInput = '';
      console.log('查询条件：', this.query.installDate);
      // 安装时间进行格式转换，转换成yyyy/MM/dd格式
      if (this.query.installDate) {
        this.query.installDate = this.query.installDate.replace(/-/g, '/');
      }
      await this.loadDeviceData();
    },

    // 设备查询-重置
    onReset() {
      this.query = {
        deviceNo: '',
        location: '',
        serviceStatus: '',
        installDate: '',
        pageNo: 1,
        pageSize: 10
      };
      this.pageInput = '';
      this.loadDeviceData();
    },

    // 设备分页-切换页码 
    changePage(page) {
      const totalPages = Math.ceil(this.deviceTotal / this.query.pageSize);
      if (page < 1 || page > totalPages) return;
      this.query.pageNo = page;
      this.pageInput = '';
      this.loadDeviceData();
    },

    // 设备分页-跳转
    jumpPage() {
      const page = Number(this.pageInput);
      const totalPages = Math.ceil(this.deviceTotal / this.query.pageSize);
      if (isNaN(page) || page < 1 || page > totalPages) {
        this.showMessage(`请输入1-${totalPages}之间的有效页码`, 'warning');
        this.pageInput = '';
        return;
      }
      this.changePage(page);
    },

    // 新增设备-打开模态框
    onCreate() {
      this.resetDeviceForm();
      this.isEditMode = false;
      this.showDeviceModal = true;
    },

    // 编辑设备-打开模态框
    async onEdit(item) {
      if (!item?.deviceId) {
        this.showMessage('设备ID异常，无法编辑', 'error');
        return;
      }
      this.resetDeviceForm();
      try {
        const isSuccess = await this.loadDeviceDetail(item.deviceId);
        if (isSuccess) {
          this.showDeviceModal = true;
        }
      } catch (error) {
        console.error('加载设备详情失败:', error);
        this.showMessage('加载设备详情失败，无法编辑', 'error');
      }
    },

    // 重置设备表单
    resetDeviceForm() {
      // 释放本地预览URL
      if (this.washQRPreviewUrl && !this.washQRPreviewUrl.startsWith('http')) {
        URL.revokeObjectURL(this.washQRPreviewUrl);
      }
      if (this.takeQRPreviewUrl && !this.takeQRPreviewUrl.startsWith('http')) {
        URL.revokeObjectURL(this.takeQRPreviewUrl);
      }
      
      this.deviceForm = {
        deviceNo: '',
        deviceName: '',
        serviceStatus: '',
        location: '',
        installTime: ''
      };
      
      // 重置文件相关
      this.washQRFile = null;
      this.takeQRFile = null;
      this.washQRPreviewUrl = '';
      this.takeQRPreviewUrl = '';
      
      this.editingDeviceId = '';
      this.isEditMode = false;
      this.submitting = false;
      
      // 清空文件输入
      if (this.$refs.washFileInput) {
        this.$refs.washFileInput.value = '';
      }
      if (this.$refs.takeFileInput) {
        this.$refs.takeFileInput.value = '';
      }
    },

    // 关闭设备模态框
    closeDeviceModal() {
      this.showDeviceModal = false;
      this.resetDeviceForm();
    },

    // ---------------------- 故障统计相关方法 ----------------------

    // 故障状态显示文本映射
    getFaultStatusShowText(item) {
      if (item.handleStatusName === 'Resolved'||item.handleStatusName === '已解决') {
        return '已处理';
      }
      if (item.handleStatusName === 'Pending'||item.handleStatusName === '待处理') {
        return '待处理';
      }
      if (item.handleStatusName === 'Processing'||item.handleStatusName === '处理中') {
        return '处理中';
      }
      return '--';
    },

    // 故障查询-搜索
    async onFaultSearch() {
      // 不选择日期的时候，不进行验证
      if (this.startDateInput === '' && this.endDateInput === '') {
        this.faultStartDate = '';
        this.faultEndDate = '';
        await this.loadFaultData();
      } else {
        // 判断日期
        this.handleDateChange();
      }
    },

    // 日期变化处理函数
    handleDateChange() {
      if (!this.startDateInput || !this.endDateInput) {
        this.showMessage('日期选择不完整', 'warning');
        return;
      }
      
      console.log('开始验证日期');
      const query = {
        startDate: this.startDateInput,
        endDate: this.endDateInput
      };
      console.log('验证日期参数：', query);

      // 验证日期范围(最大365天)
      const isValid = validateDateRange(
        query,
        this.showMessage,
        365
      );
      
      if (isValid) {
        console.log('日期有效，获取数据');
        this.faultStartDate = this.startDateInput.replace(/-/g, '/');
        this.faultEndDate = this.endDateInput.replace(/-/g, '/');
        this.loadFaultData();
      } else {
        this.showMessage('日期选择无效，请重新选择', 'warning');
        this.endDateInput = '';
        this.startDateInput = '';
      }
    },

    // 故障查询-重置
    onFaultReset() {
      this.faultQuery = {
        deviceNo: '',
        location: '',
        handleStatus: '',
        pageNo: 1,
        pageSize: 10
      };
      // 清空日期输入框
      this.startDateInput = '';
      this.endDateInput = '';
      // 清空发送到接口的日期
      this.faultStartDate = '';
      this.faultEndDate = '';
      // 清空页码输入
      this.faultPageInput = '';
      this.loadFaultData();
    },

    // 故障分页-切换页码
    changeFaultPage(page) {
      const totalPages = Math.ceil(this.faultTotal / this.faultQuery.pageSize);
      if (page < 1 || page > totalPages) return;
      this.faultQuery.pageNo = page;
      this.faultPageInput = '';
      this.loadFaultData();
    },

    // 故障分页-跳转
    jumpFaultPage() {
      const page = Number(this.faultPageInput);
      const totalPages = Math.ceil(this.faultTotal / this.faultQuery.pageSize);
      if (isNaN(page) || page < 1 || page > totalPages) {
        this.showMessage(`请输入1-${totalPages}之间的有效页码`, 'warning');
        this.faultPageInput = '';
        return;
      }
      this.changeFaultPage(page);
    },

    // 故障处理-打开模态框
    onHandleFault(item) {
      this.faultForm = {
        faultId: item.faultId,
        deviceNo: item.deviceNo,
        faultDescription: item.faultDescription,
        currentStatus: item.handleStatus,
        currentStatusName: this.getFaultStatusShowText(item),
        handleStatus: ''
      };
      this.showFaultModal = true;
    },

    // 故障处理-提交状态修改
    async saveFaultHandle() {
      if (!this.faultForm.handleStatus) {
        this.showMessage('请选择处理状态', 'warning');
        return;
      }
      
      const data = {
        faultId: this.faultForm.faultId,
        handleStatus: this.faultForm.handleStatus
      };   
      this.closeFaultModal();
      // 显示处理中的消息
      await this.handleFaultAction(data);
    },

    // 关闭故障处理模态框
    closeFaultModal() {
      this.showFaultModal = false;
      this.faultForm = {
        faultId: '',
        deviceNo: '',
        faultDescription: '',
        currentStatus: '',
        currentStatusName: '',
        handleStatus: ''
      };
    },

    // ---------------------- 使用统计相关方法 ----------------------

    // 使用统计-搜索
    async onStatsSearch() {
      if (!this.statsQuery.deviceId) {
        this.showMessage('请先选择设备ID', 'warning');
        return;
      }
      
      // 设置已搜索标志
      this.hasSearched = true;
      
      console.log('查询条件：', this.statsQuery.deviceId);
      await this.loadUsageStatistics(this.statsQuery.deviceId);
    },

    // 使用统计-重置
    onStatsReset() {
      this.statsQuery.deviceId = '';
      this.selectedDeviceStats = null;
      this.hasSearched = false; // 重置搜索标志
    },

    // 转换故障率为图表所需数据
    getFaultRateChartData(device) {
      const { faultCount = 0, normalCount = 0 } = device.faultRate || {};
      return [
        { value: faultCount, name: '故障次数', color: '#ee6666' },
        { value: normalCount, name: '正常次数', color: '#91cc75' }
      ];
    },
    
    // ---------------------- 公共方法 ----------------------
 
    // 切换Tab
    async switchTab(tab) {
      this.activeTab = tab.label;
      if (tab.label === '使用统计') {
        // 切换到使用统计时，加载设备选项
        await this.loadDeviceOptionsForStats();
      }
    },

    // 刷新当前Tab数据
    async onRefresh() {
      this.loading = true;
      try {
        if (this.activeTab === '设备信息') {
          await this.loadDeviceData();
        } else if (this.activeTab === '故障统计') {
          await this.loadFaultData();
        } else if (this.activeTab === '使用统计') {
          if (this.statsQuery.deviceId) {
            await this.loadUsageStatistics(this.statsQuery.deviceId);
          } else {
            await this.loadDeviceOptionsForStats();
          }
        }
        this.showMessage('数据刷新成功', 'success');
      } catch (error) {
        console.error('刷新数据失败:', error);
        this.showMessage('数据刷新失败', 'error');
      } finally {
        this.loading = false;
      }
    },

    // 服务状态样式类
    getStatusClass(status) {
      const map = {
        'NORMAL': 'status-normal',
        'OFFLINE': 'status-offline',
        'FAULT': 'status-fault',
        'MAINTENANCE': 'status-maintenance'
      };
      return map[status] || '';
    },

    // 故障状态样式类
    getFaultStatusClass(status) {
      const map = {
        'PENDING': 'status-pending',
        'RESOLVED': 'status-resolved',
        'PROCESSING': 'status-processing'
      };
      return map[status] || '';
    },

    // 图片加载错误处理
    handleImageError(event) {
      event.target.style.display = 'none';
      event.target.parentElement.innerHTML = '<div class="no-image">图片加载失败</div>';
    },

    // 消息提示
    showMessage(message, type = 'info') {
      // 使用 Element UI 的消息组件（如果有）
      if (window.$message) {
        switch (type) {
          case 'success':
            window.$message.success(message);
            break;
          case 'error':
            window.$message.error(message);
            break;
          case 'warning':
            window.$message.warning(message);
            break;
          default:
            window.$message.info(message);
        }
      } else {
        // 降级使用 alert
        switch (type) {
          case 'success':
            alert(`成功：${message}`);
            break;
          case 'error':
            alert(`错误：${message}`);
            break;
          case 'warning':
            alert(`警告：${message}`);
            break;
          default:
            alert(`提示：${message}`);
        }
      }
    }
  }
}
</script>

<style scoped>
/* 图片预览样式 */
.image-preview-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
  background-color: rgba(0, 0, 0, 0.8);
}

.image-preview-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  cursor: default;
}

.image-preview-tools {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}

.preview-close-btn {
  padding: 10px 20px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.preview-close-btn:hover {
  background: #d32f2f;
}

/* 通用样式 */
img {
  object-fit: contain;
  vertical-align: middle;
}

.completed-text {
  color: #45a049;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  line-height: 1.4;
  font-weight: bold;
}

/* 二维码样式 */
.qrcode-cell {
  text-align: left;
  vertical-align: middle;
}

.qrcode-image {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  vertical-align: middle;
}

.no-image {
  color: #999;
}

/* 按钮样式 */
.btn-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #2196F3;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 20px;
  line-height: 1.4;
  flex-shrink: 0;
}

.btn-edit:hover {
  background: #1976D2;
}

.btn-delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #F44336;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  line-height: 1.4;
  flex-shrink: 0;
}

.btn-delete:hover {
  background: #D32F2F;
}

/* 洗衣程序样式 */
.program-item {
  display: inline-block;
  margin-right: 5px;
  font-size: 14px;
}

.no-program {
  color: #999;
}

/* 故障描述样式 */
.fault-description {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

/* 使用统计区域样式 */
.use-stats-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
  max-width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

.use-stats-single {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.use-stats-card {
  width: 100%;
  height: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  margin: 0;
  box-sizing: border-box;
}

.use-stats-card-title {
  width: 100%;
  height: 10%;
  display: flex;
  flex-direction: row;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  margin-bottom: 5px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
}

.use-stats-label {
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 24px;
  color: #666;
}

.use-stats-icon {
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.device-id {
  font-size: 16px;
  color: #999;
  margin-left: 10px;
  font-weight: normal;
}

.use-stats-card-content {
  width: 100%;
  height: 90%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

/* 统计行样式 */
.stats-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
  box-sizing: border-box;
}

.stat-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
}

.stat-label {
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 10px;
}

.full-width {
  grid-column: 1 / -1;
}

/* 基本统计样式 */
.stat-charts {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.basic-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
}

.stat-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin: 5px;
}

.stat-value {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 150px;
  font-size: 30px;
  background-color: #73c0de;
  border-radius: 4px;
  color: white;
}

/* 图表容器 */
.stat-chart-container {
  width: 100%;
  height: 180px;
  min-width: 150px;
  box-sizing: border-box;
  padding-top: 10px;
  overflow: hidden;
}

.bar-chart-container {
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  overflow: hidden;
}

/* 故障处理统计 */
.fault-handle-stats {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
  width: 100%;
  min-height: 120px;
  box-sizing: border-box;
  padding-top: 30px;
}

.fault-stat {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  line-height: 1.4;
  width: 100%;
  justify-content: center;
}

/* 提示信息样式 */
.select-device-prompt,
.no-data-prompt {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.prompt-content {
  text-align: center;
  padding: 40px;
}

.prompt-icon {
  font-size: 48px;
  margin-bottom: 20px;
  opacity: 0.6;
}

.prompt-text {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

/* 加载状态 */
.loading-container {
  text-align: center;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.loading-text {
  color: #666;
  font-size: 16px;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 10px 20px;
  border-bottom: 2px solid #e0e0e0;
}

.modal-header h3 {
  margin: 0;
  font-size: 24px;
  color: #333;
  flex: 1;
  text-align: center;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  color: #999;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  align-self: center;
  margin-left: auto;
}

.close-btn:hover {
  background: #f5f5f5;
  color: #666;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  text-align: left;
  font-weight: bold;
  color: #333;
}

.form-input-modal {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input-modal:focus {
  outline: none;
  border-color: #4caf50;
}

.form-hint {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 2px solid #e0e0e0;
  align-items: center;
}

.btn-cancel {
  padding: 8px 16px;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  color: #666;
  line-height: 1.4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-cancel:hover {
  background: #e9e9e9;
}

.btn-confirm {
  padding: 8px 16px;
  background: #4caf50;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: white;
  line-height: 1.4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-confirm:hover {
  background: #45a049;
}

.btn-confirm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 上传组件样式 */
.upload-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.image-preview {
  position: relative;
  width: 100%;
  max-width: 200px;
  margin-bottom: 10px;
}

.preview-img {
  width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: contain;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
}

.remove-image {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f44336;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
}

.remove-image:hover {
  background: #d32f2f;
}

.upload-area {
  border: 2px dashed #ddd;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.upload-area:hover {
  border-color: #4caf50;
  background: #f9f9f9;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.upload-icon {
  font-size: 24px;
}

.upload-hint {
  font-size: 12px;
  color: #999;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .stats-row {
    grid-template-columns: 1fr;
  }
}
</style>